<!------------------------------------------------>
<!-- HTML定義 ------------------------------------->
<!------------------------------------------------>
<!-- SVGのコンポーネント化 -->
<template>
  <component :is="svg"/>
</template>

<script>
export default {
  name: "svg_elements",
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    svg() {
      return () => import(`@/assets/svg/${this.name}.svg`)
    }
  }
}
</script>